import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
// App routing
import { DocumentApp } from './apps';
// Main App Component - This works as a router
const Main = ({ appType, pageData }) => {
    // Access WordPress data passed from PHP
    const wpData = window.wpReactData;
    switch (appType) {
        case 'document-app':
            return _jsx(DocumentApp, { pageData: pageData });
        default:
            return (_jsx("section", { className: "react-app", children: _jsxs("div", { className: "container", children: [_jsx("h2", { children: "Apps Declaration Missing" }), _jsx("em", { children: "Specify which App to render." })] }) }));
    }
};
// Initialize React app when DOM is ready
const initializedReactApps = () => {
    // Look for elements with class 'react-app-mount' to mount React apps
    const mountPoints = document.querySelectorAll('.react-app-mount');
    mountPoints.forEach((element) => {
        try {
            const appType = element.getAttribute('data-app-type'), pageDataAttr = element.getAttribute('data-page-data'), pageData = JSON.parse(pageDataAttr || '{}'), root = createRoot(element);
            root.render(_jsx(Main, { appType: appType, pageData: pageData }));
        }
        catch (error) {
            console.error('Error mounting the react app:', error);
        }
    });
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializedReactApps);
}
else {
    // DOM is already read
    initializedReactApps();
}
export default Main;
